/**
 * Množné číslo.
 *
 * Čeština má tři tvary (1 / 2–4 / 5 a víc), angličtina dva, ruština a
 * ukrajinština zase tři, ale jinak rozdělené. Sázet na „když není jedna, dej
 * množné" znamená mít v půlce jazyků špatné tvary.
 *
 * `tvary` bere pravidla přímo z prohlížeče (`Intl.PluralRules`), takže se
 * nemusí opisovat pro každý jazyk zvlášť. `mnozne` je zkratka pro češtinu,
 * kterou používá `lang/cs.js`.
 */

/**
 * České tvary: `mnozne(3, 'člen', 'členové', 'členů')`.
 */
export const mnozne = (pocet, jedna, dve, pet) => {
  if (pocet === 1) return jedna;
  if (pocet >= 2 && pocet <= 4) return dve;
  return pet;
};

// Prohlížeč umí `Intl.PluralRules` už dlouho, ale kdyby ne (starý webview),
// spadne se na rozlišení jedna / ostatní. To je pro každý jazyk aspoň
// pochopitelné, i když ne vždy správné.
const pravidla = new Map();

function vyber(jazyk, pocet) {
  if (typeof Intl === 'undefined' || !Intl.PluralRules) {
    return pocet === 1 ? 'one' : 'other';
  }
  if (!pravidla.has(jazyk)) {
    try {
      pravidla.set(jazyk, new Intl.PluralRules(jazyk));
    } catch {
      pravidla.set(jazyk, null);
    }
  }
  const pravidlo = pravidla.get(jazyk);
  return pravidlo ? pravidlo.select(pocet) : (pocet === 1 ? 'one' : 'other');
}

/**
 * Tvar podle jazyka: `tvary('es', 2, { one: 'miembro', other: 'miembros' })`.
 *
 * Klíče jsou názvy tvarů podle `Intl.PluralRules` (one, two, few, many,
 * other). Když daný tvar chybí, použije se `other`.
 */
export function tvary(jazyk, pocet, moznosti) {
  const tvar = vyber(jazyk, pocet);
  return moznosti[tvar] !== undefined ? moznosti[tvar] : moznosti.other;
}
